export enum PASSWORD_STRENGTH {
  LOW = 33.3,
  MEDIUM = 66.6,
  HIGH = 100,
  ERROR = 101
}
